export const isBarcodeInputValid = (barcodeInput: string) => {
  const regexObj = {
    barcode: /^[A-Z,0-9]{8}$/,
    ups: /^1Z[A-HJ-NPR-Z0-9]{16}$/,
    dhl: /^[0-9]{10}$|^JD[0-9]{18}$/,
    royal_mail: /^(?!(EA|EB|EC|ED|EE|CP))[A-Z]{2}[0-9]{9}GB$/,
    dpd: /^([0-9]{10}|[0-9]{12}|[0-9]{14}|[0-9]{14}[A-Z]{1})$/
  }

  return Object.values(regexObj).some((regex) => regex.test(barcodeInput))
}
